<template>
  <!-- Profilo di cittadino e operatore: ogni blocco è la stessa card
       (.settings-card, testa dentro la card), 1.5rem fra un blocco e l'altro
       (mb-4); due card affiancate stanno in .settings-pair -->
  <div class="col-12 pb-4">
    <AnagraficaComponent />

    <!-- I contatti utili ci devono essere sul profilo personale solo per l'utenza cittadino -->
    <ContattiEmergenza
      v-if="user && user.type === 0 && user.email_verified_at"
      :user="user"
    ></ContattiEmergenza>
    <div v-if="user.type === 1">
      <AccessoEPermessi class="mb-4" />
      <SoapTemplatesManager />
      <div class="settings-pair mb-4">
        <NotificationChannels />
        <SessionLengthSetter
          :userSessionTimeout="user.session_timeout_minutes"
          :userHash="user.hashid"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import AnagraficaComponent from "@/app/modules/impostazioni/components/utente/AnagraficaComponent.vue";
import AccessoEPermessi from "@/app/modules/impostazioni/components/utente/AccessoEPermessi.vue";
import SoapTemplatesManager from "@/app/modules/impostazioni/components/utente/SoapTemplatesManager.vue";
import NotificationChannels from "@/app/modules/impostazioni/components/utente/NotificationChannels.vue";
import ContattiEmergenza from "@/app/modules/impostazioni/components/utente/ContattiEmergenza.vue";
import SessionLengthSetter from "@/app/modules/impostazioni/components/utente/SessionLengthSetter.vue";

export default {
  name: "Profilo",
  components: {
    AnagraficaComponent,
    AccessoEPermessi,
    SoapTemplatesManager,
    NotificationChannels,
    ContattiEmergenza,
    SessionLengthSetter,
  },
  computed: {
    ...mapState("utente", ["status", "user"]),
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions("utente", ["setAnagrafica", "me"]),
  },
  watch: {},
  created() {
    // this.me();
  },
  mounted() {},
  beforeRouteLeave(to, from, next) {
    // Admin può sempre navigare
    if (this.user.type === 2) {
      return next();
    }
    // Se la password non è scaduta e il numero è verificato, può navigare
    if (!this.user.expired_password && this.user.number_verified_at) {
      return next();
    }
    const isGoingHome = to.name === "NumberVerification" || to.name === "Home";
    // Se non ha verificato il numero può andare solo alla verifica e alla home
    if (!this.user.number_verified_at && isGoingHome) {
      return next();
    }
    // Se è un operatore con password non scaduta e numero verificato, può navigare
    if (
      this.user.type === 1 &&
      !this.user.expired_password &&
      this.user.number_verified_at
    ) {
      return next();
    }
  },
  // beforeRouteLeave(to, from, next) {
  //   if (this.user.type !== 1) {
  //     next();
  //   }
  //   if (
  //     !this.user.expired_password &&
  //     (this.user.number_verified_at ||
  //       to.name === "NumberVerification" ||
  //       to.name === "Home")
  //   ) {
  //     next();
  //   }
  // },
};
</script>
